'use client';

import { ApiErrorTracker } from '@brahma/components';
const ApiErrorTrackerWrapper = () => {
  return <ApiErrorTracker data-sentry-element="ApiErrorTracker" data-sentry-component="ApiErrorTrackerWrapper" data-sentry-source-file="apiErrorTrackerWrapper.tsx" />;
};
export default ApiErrorTrackerWrapper;